import Vue from 'vue';
import helper from '@/shared/helper';

const userModule = {
	actions: {
		clearUser({ commit }) {
			commit('clearUser');
		},
		setToken({ commit }, token) {
			commit('setToken', token);
		},
		setUser({ commit }, user) {
			commit('setUser', user);
		},
	},
	getters: {
		userName(state) {
			return state.userName;
		},
		token(state) {
			return state.token;
		},
		userAvatar(state) {
			return state.profileImage || state.profileImageDefault;
		},
		userAvatarSideBar(state) {
			return state.profileImage || state.profileImageDefaultSideBar;
		},
	},
	mutations: {
		clearUser(state) {
			Vue.set(state, 'token', null);
			Vue.set(state, 'user', null);
		},
		setToken(state, token) {
			Vue.set(state, 'token', token);
		},
		setUser(state, user) {
			Vue.set(state, 'user', user);
			Vue.set(state, 'userName', user.name || user.email || 'Nombre de Usuario');
		},
	},
	state: {
		email: '',
		logo: 'quipu-logo.svg',
		profileImage: '',
		profileImageDefault: '/static/img/icons/icono-profile-azul.svg',
		profileImageDefaultSideBar: '/static/img/sidebar/avatar_default.svg',
		token: helper.getLocalToken(),
		userName: '',
		user: {},
	},
};

export default userModule;



// WEBPACK FOOTER //
// ./src/store/modules/user/userModule.js